// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vv_a bhh_b bhh_wb"};